module.exports = __webpack_public_path__ + "img/ssfw.4948f863.png";